export default (ctx, html) => html`
<div>
  <div class="twt ${ctx.value}" @click="${ctx.toggleValue}"></div>
</div>
`;
